<template>

  <div id="unitManage">
    <div class="dialog-content">

      <div v-if="editing" class="context">To edit a unit, select a field.</div>
      <div v-else class="context">To add a unit, fill out the required fields.</div>

      <!-- PROPERTY -->
      <v-select
        ref="selectProperty"
        label="Property"
        prepend-icon="mdi-domain"
        :disabled="editing"
        :items="properties"
        item-text="name"
        item-value="_id"
        :rules="rules.property"
        v-model="unit.property"
      >
      </v-select>

      <!-- UNIT TYPE -->
      <v-select
        ref="selectUnitType"
        label="Unit Type"
        prepend-icon="mdi-home"
        :disabled="!unit.property"
        :items="unitTypes"
        item-text="name"
        item-value="_id"
        :rules="rules.unitType"
        v-model="unit.type"
      >
      </v-select>

      <!-- TITLE -->
      <v-text-field :validate-on-blur="$refs.inputTitle && $refs.inputTitle.valid" :rules="rules.title" ref="inputTitle" label="Title" v-model="unit.title" prepend-icon="mdi-format-title"></v-text-field>

      <!-- UNIT ADDRESS -->
      <div class="title-area" style="margin: 16px 0;">Unit Address</div>

      <vo-address ref="address"></vo-address>

    </div>
    <div class="dialog-footer">
      <v-btn class="button" flat color="info" @click="routeRemoveQueries(['dialog', 'dialogAction'])">Cancel</v-btn>
      <v-btn class="button" :loading="lockout.on" flat color="primary" @click="editing ? save() : create()">{{ editing ? 'Save' : 'Create' }}</v-btn>
    </div>
  </div>
</template>

<script>

import permissionMixin  from '../mixins/permissionMixin.js';

  export default {
    mixins: [permissionMixin],
    data () {
      return {
        editing: null,
        unit: {
          property: null,
          type: null,
          title: '',
          address: {}
        },
        unitTypes: [],
        rules: {
          title: [
            function (e) {
              return !window.regex.title.test(e) ? 'Please enter a title.' : true;
            }
          ],
          property: [
            function (e) {
              return !e ? 'Please select a property.' : true;
            }
          ],
          unitType: [
            function (e) {
              return !e ? 'Please select a unit type.' : true;
            }
          ]
        }
      }
    },

    props: {
      dialogComponent: {

      },
      lockout: {

      }
    },

    computed: {
      properties () {
        return this.getAccessiblePropertiesList(['unit']);
      },
    },

    methods: {
      create () {
        this.lockout.on = true;
        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout.on = false;
          return;
        } 

        this.unit.address = this.$refs.address.address;

        this.$store.dispatch('createUnit', {
          unit: this.unit
        })
        .then(data => {
          this.app.pages.units.list.addItem(data._id, {unshift: true});

          this.routeAddQuery('details', data._id);
          this.routeRemoveQuery('dialog');

          Toast.show('Unit created.', 'success');
          this.lockout.on = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.lockout.on = false;
        })
      },

      save () {
        this.lockout.on = true;
        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout.on = false;
          return;
        }
   
        this.unit.address = this.$refs.address.address;

        this.$store.dispatch('updateUnit', {
          unit: this.unit
        })
        .then(data => {
          this.routeRemoveQuery('dialog');
    
          Toast.show('Unit updated.', 'success');
          this.lockout.on = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.lockout.on = false;
        });
      },

      validate () {
        this.$refs.inputTitle.validate(true);
        this.$refs.address.validate();
        this.$refs.selectProperty.validate(true);
        this.$refs.selectUnitType.validate(true);

        return (this.$refs.inputTitle.valid &&
                this.$refs.address.valid &&
                this.$refs.selectProperty.valid &&
                this.$refs.selectUnitType.valid);
      }
    },

    watch: {
      'unit.property' () {
        
        if (!this.unit.property) return;

        this.$refs.address.init(this.$store.getters.property(this.unit.property).address);

        this.$store.dispatch('loadUnitTypes', {
          property: this.unit.property
        })
        .then(data => {
          this.unitTypes = data.sort((a, b) => {
            return a.name < b.name ? -1 : 1;
          });
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
        });
      }
    },

    created () {
      this.editing = this.$route.query.dialogAction && this.$route.query.dialogAction === 'edit';

      if (this.editing) {
        this.unit = this.$store.getters.unit(this.app.pages.units.selected);
        
        this.$nextTick(() => {
          this.$refs.address.init(this.unit.address);
        });
      }
      else {
        if (this.app.pages.units.filtering.filters.property.value !== 'all') {
          this.unit.property = this.app.pages.units.filtering.filters.property.value;
        }
      }

      this.title = this.editing ? 'Edit Unit' : 'Create Unit'; 
      this.$emit('title', this.title);
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #unitManage {
    position: relative;

    .dialog-content {
      padding: 16px;
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/UnitManage.vue